<template>
  <div :class="menuClass + ' custom-container'">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="profil page-wrapp">
      <v-row class="justify-center">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <v-row class="align-center">
            <v-col v-on:click="goToLink('#/profil')" cols="1">
              <v-btn elevation="2" icon
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </v-col>
            <v-col cols="11">
              <v-card-title>Personling informasjon</v-card-title>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="justify-center pt-0 mt-0">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'justify-content-center pt-0 mt-0'
              : 'pt-0 mt-0'
          "
        >
          <v-row>
            <v-col
              cols="11"
              :class="!$vuetify.breakpoint.smAndDown ? 'ml-15' : ''"
            >
              <v-row class="pt-0 mt-0">
                <v-col class="text-left text--secondary">Navn</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0"
                  ><v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{
                      (customer.GivenName + " " + customer.FamilyName).trim() ||
                      customer.Name
                    }}</v-card-title
                  ></v-col
                >
              </v-row>
              <v-row class="pt-0 mt-0">
                <v-col class="text-left text--secondary">{{
                  (customer.Identification || "").length > 9
                    ? "Fødselsdag"
                    : "Organisasjonsnummer"
                }}</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0"
                  ><v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{ customer.IdentificationShort }}</v-card-title
                  ></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" v-on:click="snackbar = false">
          Lukke
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { getNorwayMonth } from "../../utils/date";
import { customer } from "../../api/common";

import "./Profil.scss";

export default {
  name: "Profil",

  components: {},

  data() {
    return {
      loader: false,
      customer: {},
      menuClass: "",
      snackbar: false,
      snackbarText: "",
    };
  },

  async mounted() {
    await this.getDataFromApi();

    if (localStorage.tenant === "9876543210517") {
      this.menuClass = "sokrates";
    } else if (localStorage.tenant === "7080010002488") {
      this.menuClass = "klark";
    } else {
      this.menuClass = "hks";
    }
  },

  methods: {
    goToLink(route) {
      let tmp = document.createElement("a");
      tmp.href = route;
      tmp.click();
    },

    getNorwayMonth(month) {
      return getNorwayMonth(month);
    },

    async getDataFromApi() {
      this.loader = true;
      this.customer = {};

      try {
        let tmpCustomer = await customer();
        tmpCustomer = tmpCustomer.data;

        this.customer = this.decorateCustomer(tmpCustomer);
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = "Feil ved innlasting av data ";
      }

      this.loader = false;
    },

    decorateCustomer(item) {
      let decoratedCustomer = Object.assign({}, item);
      decoratedCustomer.Identification = decoratedCustomer.Identification || "";
      decoratedCustomer.IdentificationShort =
        decoratedCustomer.Identification.length > 9
          ? decoratedCustomer.Identification.substring(0, 2) +
            "." +
            decoratedCustomer.Identification.substring(2, 4) +
            "." +
            decoratedCustomer.Identification.substring(4, 6)
          : decoratedCustomer.Identification;
      return decoratedCustomer;
    },
  },
};
</script>
